export default function formatTime(seconds) {
  seconds = Number.parseInt(seconds);
  if (!seconds) return "00:00";
  var h = Math.floor(seconds / 3600);
  var min = Math.floor((seconds - h * 3600) / 60);
  var sec = seconds - h * 3600 - min * 60;

  if (h < 10) {
    h = "0" + h;
  }
  if (min < 10) {
    min = "0" + min;
  }
  if (sec < 10) {
    sec = "0" + sec;
  }
  return (h + ":" + min + ":" + sec).replace(/^00:/, "");
}